import { Box, Button, Grid, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import Prticless from './Particle'
import Design from './Design'
import MainSkills from './MainSkills'
import hafeez from "../hafeez..jpeg"
import Intro from './Intro'
import Sets from './Sets'
import { ProjData, backProject } from '../Comp/ProjData'
import NavCrum from './Nav'
import Capture from "../Capture.jpeg"
import Github from "../Github.jpeg"
import { cilExpandRight } from '@coreui/icons'
import { getFile } from '../Firebase/MainFirebase'
import { useState } from 'react'
import { RevealWrapper } from 'next-reveal'
import VisitorCounter from '../Comp/VisitorCounter'
import axios from 'axios'
import { Link } from 'react-router-dom'
import GoogleReviews from './GoogleReviews'
import Footer from './Footer'

// let pdf = "file:///C:/Users/dell/Desktop/Upadate%20Cv%203%20year.pdf"

const Abc = () => {
  let baseUrl = "https://chatbotesreactnode-production.up.railway.app"
  const [getImg, setImg] = useState()
  const [bachelorIndex, setBachelorIndex] = useState(0)
  const [bachelorFade, setBachelorFade] = useState(true)
  const bachelorImages = [
    require("../images/bachelor-image1.jpeg"),
    require("../images/bachelor-image2.jpeg")
  ]

  const handleBachelorTransition = (nextIndex) => {
    setBachelorFade(false)
    setTimeout(() => {
      setBachelorIndex(nextIndex)
      setBachelorFade(true)
    }, 250)
  }

  useEffect(() => {
    const timer = setInterval(() => {
      handleBachelorTransition(bachelorIndex === 0 ? 1 : 0)
    }, 4500)
    return () => clearInterval(timer)
  }, [bachelorIndex])

  let darkMode = true

  let icn = [
    {
      con: "linkedin",
      // key:"https://www.facebook.com/hafeez.hussain.98"
      key: "https://www.linkedin.com/in/hafeez-atif-2005h/"
    },
    {
      con: "github",
      key: "https://github.com/Hafeezdeveloper"
    },
    {
      con: "instagram",
      key: "https://www.instagram.com/hafeezhussaun/"
    },
  ]
  const clkBtn = (e) => {
    console.log(e)
  }

  const [visitorCount, setVisitorCount] = useState(0);
  const [statsData, setStatsData] = useState(null);

  const fetchVisitorCount = async () => {
    try {
      const response = await axios.get('https://hafeezatifbackend.vercel.app/api/visitor-count');
      setVisitorCount(response.data.count);
    } catch (err) {
      console.error('Error fetching visitor count:', err);
    }
  };

  useEffect(() => {
    fetchVisitorCount();
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    if (visitorCount > 0) {
      setStatsData([
        { value: 37, label: "DESTINATIONS" },
        { value: 22, label: "HAPPY CLIENTS" },
        { value: visitorCount + 156, label: "Total Vistors" },
        { value: 65, label: "UNIQUE IDEAS" }
      ]);
    }
  }, [visitorCount]); // This runs only when visitorCount changes



  // const downFle = (e) =>{
  //   getFile()
  //   .then( (succ) =>{
  //     console.log(succ)
  //     setImg(succ)
  //   })
  //   .catch( (err) =>{
  //     console.log(err)
  //   })
  // }

  useEffect(() => {
    getFile()
      .then((succ) => {
        console.log("sad", succ)
      }).catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <>
      <Box className='overflow-hidden'>
        <RevealWrapper origin='left' delay={200} duration={1000} distance='500px' reset={true} viewOffset={{ top: 25, right: 0, bottom: 10, left: 5 }}>
          <Typography className='d-flex justify-content-center fw-bold ' sx={{ color: "#31F711" }} variant='h4'>Portfolio</Typography>
        </RevealWrapper>
      </Box>
      <Box>
        <Prticless />

        {/* <Design /> */}

        <Box className='d-flex justify-content-center my-5'>
          {/* ======Main1para==== */}
          <MainSkills />

          {/* ======Main1para==== */}
        </Box>

        <Box sx={{ height: "300px" }} className='d-flex  justify-content-center '>
          <Box>
            <img className='img_hvr' id='img_hvr' style={{ borderRadius: "20%" }} width={"175px"} src={hafeez} alt="" />
          </Box>
        </Box>


        <Box>
          <Intro />
        </Box>

        <Box>
          <Sets />
        </Box>
      </Box>

      <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        <Typography className='my-3 ' style={{ color: "#31F711" }} variant='h4'>About Me</Typography>
        <div className='d-flex align-items-center mb-3 h-auto'>

          <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial" }}>
            Linkedin Profile
          </Typography>
          <Typography className='para_main mt-3 fs-sm-6' variant='h6' sx={{ fontFamily: "-moz-initial" }}>
            <a className='small_size' href="https://www.linkedin.com/in/hafeez-atif-2005h/">https://www.linkedin.com/in/hafeez-atif-2005h/</a>
          </Typography>
        </div>

        <Grid className='' container>
          <img style={{ width: "100%" }} src={require("../images/hafez.gif")} alt="" />
          <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15, }}>
            If you search  <span className='my-2' style={{ color: "#31F711" }} variant='p'> "Hafeez Atif developer" </span> on <span className='my-2' style={{ color: "#31F711" }} variant='p'> "Google" </span>  , you will find my professional profile prominently displayed. As a Full Stack Developer  .I specialize in backend technologies like Nest js ,Node.js and possess proficient skills in frontend development with React.js .My versatility and capability as a software developer.
          </Typography>
        </Grid>
      </Box>
      <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        <img style={{ width: "100%" }} src={require("../images/Capture.png")} alt="" />
        <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15, }}>
          <span className='my-2' style={{ color: "#31F711", fontWeight: "bold" }} variant='h6'> I have developed a Mobile app that is live on the Play Store, which relates to quizzes and games. </span>
        </Typography>
      </Box>
      <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        <img style={{}} src={require("../images/gif2.gif")} alt="" />
        <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15, }}>
          <span className='my-2' style={{ color: "#31F711", fontWeight: "bold" }} variant='h6'> I have developed another Mobile app </span>
        </Typography>
      </Box>
      <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        <Typography className='my-3' style={{ color: "#31F711", fontWeight: "bold" }} variant='h4'>Fitness Gym App</Typography>
        <Grid container spacing={3} className='my-3' justifyContent="center">
          <Grid item xs={12} sm={4} className="d-flex justify-content-center">
            <img style={{ width: "100%", maxWidth: "280px", borderRadius: "15px", border: "3px solid #31F711", boxShadow: "0px 4px 20px rgba(49, 247, 17, 0.3)" }} src={require("../images/image1.jpeg")} alt="Fitness Gym App 1" />
          </Grid>
          <Grid item xs={12} sm={4} className="d-flex justify-content-center">
            <img style={{ width: "100%", maxWidth: "280px", borderRadius: "15px", border: "3px solid #31F711", boxShadow: "0px 4px 20px rgba(49, 247, 17, 0.3)" }} src={require("../images/image2.jpeg")} alt="Fitness Gym App 2" />
          </Grid>
          <Grid item xs={12} sm={4} className="d-flex justify-content-center">
            <img style={{ width: "100%", maxWidth: "280px", borderRadius: "15px", border: "3px solid #31F711", boxShadow: "0px 4px 20px rgba(49, 247, 17, 0.3)" }} src={require("../images/image3.jpeg")} alt="Fitness Gym App 3" />
          </Grid>
        </Grid>
        <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15 }}>
          <span className='my-2' style={{ color: "#31F711", fontWeight: "bold" }} variant='h6'> I have developed a Fitness Gym Mobile Application featuring workout tracking, dynamic routines, and a user-friendly fitness tracker. </span>
        </Typography>
      </Box>
      {/* <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        <Typography className='my-2' style={{ color: "#31F711" }} variant='h4'>Projects</Typography>
        <Grid className='' container>

        </Grid>


      </Box> */}

      <Box className='container my-5' sx={{ position: "relative", zIndex: 1 }}>
        {statsData !== null ?
          <VisitorCounter statsData={statsData} />
          : null
        }
        <Link to="/chat" style={{ textDecoration: "none" }}>
          <Tooltip title="This section is about integrating the Chat Bot">
            <Typography className='my-2' style={{ color: "#31F711" }} variant='h4'>
              Chat Bot Integration :
            </Typography>
          </Tooltip>        </Link>
        <Grid container>
          <Grid xs={12} sm={12} md={12} >
            <Link to="/chat">
              <img style={{ width: "100%" }} src={require("../images/aibanner.jpg")} alt="" />
            </Link>
          </Grid>
          <Grid className='my-5' xs={12} sm={12} md={12}  >
            <Typography className='my-2 fw-bold' style={{ color: "black" }} variant='p'>Ask the chat bot about my skills and projects to get detailed insights into my expertise and experience. </Typography>
            <Link to="/chat" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#31F711",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "30px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = "#28c108"}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = "#31F711"}
              >
                Click Me
              </Button>
            </Link>
          </Grid>
        </Grid>

        <Typography className='my-3' style={{ color: "#31F711", fontWeight: "bold" }} variant='h4'>Education</Typography>
        <Grid container justifyContent="center" className='my-3'>
          <Grid item xs={12} sm={8} md={6}>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '450px',
                margin: '0 auto',
                borderRadius: '15px',
                border: '3px solid #31F711',
                boxShadow: '0px 4px 20px rgba(49, 247, 17, 0.3)',
                overflow: 'hidden',
                backgroundColor: 'rgba(20, 20, 20, 0.8)',
                aspectRatio: '4/3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img
                src={bachelorImages[bachelorIndex]}
                alt={`Bachelor Degree Page ${bachelorIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  opacity: bachelorFade ? 1 : 0,
                  transform: bachelorFade ? 'scale(1)' : 'scale(0.96)',
                  transition: 'opacity 0.25s ease-in-out, transform 0.25s ease-in-out',
                }}
              />
              <Button
                onClick={() => handleBachelorTransition(bachelorIndex === 0 ? 1 : 0)}
                sx={{
                  position: 'absolute',
                  left: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  minWidth: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(49, 247, 17, 0.7)',
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  lineHeight: '1',
                  p: 0,
                  '&:hover': {
                    backgroundColor: '#31F711',
                  }
                }}
              >
                &#8249;
              </Button>
              <Button
                onClick={() => handleBachelorTransition(bachelorIndex === 0 ? 1 : 0)}
                sx={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  minWidth: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(49, 247, 17, 0.7)',
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  lineHeight: '1',
                  p: 0,
                  '&:hover': {
                    backgroundColor: '#31F711',
                  }
                }}
              >
                &#8250;
              </Button>
              <Box
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  color: '#31F711',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: '10px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  border: '1px solid #31F711'
                }}
              >
                {bachelorIndex + 1} / 2
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1.5 }}>
              <Box
                onClick={() => handleBachelorTransition(0)}
                sx={{
                  width: bachelorIndex === 0 ? '12px' : '8px',
                  height: bachelorIndex === 0 ? '12px' : '8px',
                  borderRadius: '50%',
                  backgroundColor: bachelorIndex === 0 ? '#31F711' : 'rgba(49, 247, 17, 0.3)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
              />
              <Box
                onClick={() => handleBachelorTransition(1)}
                sx={{
                  width: bachelorIndex === 1 ? '12px' : '8px',
                  height: bachelorIndex === 1 ? '12px' : '8px',
                  borderRadius: '50%',
                  backgroundColor: bachelorIndex === 1 ? '#31F711' : 'rgba(49, 247, 17, 0.3)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15 }}>
          <span className='my-2' style={{ color: "#31F711", fontWeight: "bold" }} variant='h6'> I hold a Bachelor's degree in Computer Science. My academic foundation includes software engineering, database systems, web technologies, and computational architectures. </span>
        </Typography>

        <Typography className='my-2 ' style={{ color: "#31F711" }} variant='h4'>Backend</Typography>
        <Grid className='' container>
          {backProject.map((x, i) => {
            console.log(x)
            return (
              <>
                <Grid className="my-3 overflow-hidden" item md={12} sm={12} xs={12} >
                  <RevealWrapper origin='right' delay={200} duration={1000} distance='500px' reset={true} viewOffset={{ top: 25, right: 0, bottom: 10, left: 5 }}>

                    <Typography className='my-2 fw-bold' style={{ color: "black" }} variant='h4'>GitHub :</Typography>
                    <a className='txt_blk' style={{ color: "#31F711" }} href={x.project}>{x.project}</a>
                    <Typography className='my-2 fw-bold' style={{ color: "black" }} variant='p'> <span style={{ color: "#31F711" }}> {" "} Portal Backend</span> ( Node Js , Express Js , Controller ,Authentication , Password Encoding ,Mongo db, Cloudinary)</Typography>
                  </RevealWrapper>
                </Grid>
              </>
            )
          })}
        </Grid>


      </Box>



      <Box className="my-3">
        <Grid container>
          <Grid className='m-auto' item xs={12} md={8} sm={8}>
            <img width={"100%"} src={Github} alt="" />
          </Grid>
        </Grid>
      </Box>

      <GoogleReviews />

      <Box sx={{ position: "relative", zIndex: 1 }} className='d-flex justify-content-center'>
        {icn.map((x, i) => {
          return (
            <Box className='mx-2'>
              <a className='on_hvr' href={x.key}><img onClick={() => clkBtn(x)} src={`https://skillicons.dev/icons?i=${x.con}&theme=${darkMode ? "dark" : "light"}`} /></a>
            </Box>
          )
        })}

      </Box>

      <Box sx={{ position: "relative", zIndex: 1 }} className='container d-flex justify-content-center my-5'>
        <Box className='mx-2 d-flex justify-content-between w-100'>
          <Button className='rounded' sx={{ backgroundColor: "#31F711" }}><a style={{ textDecoration: "none", color: "white" }} target='_blank' href="https://firebasestorage.googleapis.com/v0/b/apple-web-95776.appspot.com/o/images%2FFull%20stack%20Developer.pdf37a410fa-9c31-4192-8e87-f1d1fd520731?alt=media&token=5ea617da-0690-4fd5-8ad1-26da91d6760d">Download CV</a> </Button>
          <Button className='rounded' sx={{ backgroundColor: "#31F711" }}><a style={{ textDecoration: "none", color: "white" }} target='_blank' href="mailto:hafeez.hussain2003@gmail.com">Mail Me</a> </Button>
        </Box>
      </Box>

      <Footer />

    </>
  )
}

export default Abc
